import { BASE_URL } from '../config';
import axiosApiInstance from '../../interceptors/axiosApiInstance';

const UserService = {
    postUser: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + '/user', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAllUsers: async function () {
        try {
            return await axiosApiInstance.get(await BASE_URL + '/user');
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getUserByID: async function (params) {
        try {
            return await axiosApiInstance.get(await BASE_URL + `/user/getById?userId=${params}`);
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteUsers: async function (params) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + '/user/bulk-delete', {
                userId: params
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    changeStatus: async function (id, status) {
        try {
            return await axiosApiInstance.put(await BASE_URL + `/user/${id}/change-status`, {
                status: `${status}`
            });
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateUser: async function (data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + '/user', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getRolePermission: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + '/user/role-permission-tag');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { status: false, message: 'NETWORK-ERROR' };
        }
    },
    generateAPIKey: async function () {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + '/user/api-key-generate');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { status: false, message: 'NETWORK-ERROR' };
        }
    },
    getAPIKey: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + '/user/api-key');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { status: false, message: 'NETWORK-ERROR' };
        }
    }
};

export default UserService;
